// dbext:profile=staging_mcdo2019_be
import $         from "jquery";
import flatpickr from "flatpickr";

import admin_general                  from "./905-admin_general.js";
import admin_crud                     from "./910-admin_crud.js";
import admin_restaurant_opening_hours from "./932-admin_restaurant_opening_hours.js";
import admin_tinymce                  from "./914-admin_tinymce.js";

export default {

    async init()
    {
        // only interfere with the right page
        if ( $('.c-admin-openinghours-schedule' ).length == 0 ){
            return;
        }

        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // event handlers
        $('.js-form').on( 'submit', this.on__form__submit() );

        // reset all checkboxes (they get checked later)
        $('input[type="checkbox"]').prop( 'checked', false );

        // default check sync to GMB checkbox
        $('input[type="checkbox"][name="sync_to_gmb"]').prop( 'checked', true );

        // init opening hours
        admin_restaurant_opening_hours.init_opening_hours();

        var today = new Date();
        $('input[name="schedule_date"]').val( new Date().toISOString().slice(0,10) );
        $('input[name="schedule_time"]').val('00:00');

        // init flatpickr date
        flatpickr( $( 'input[name="schedule_date"]' ), {
            inline          : true      ,
            dateFormat      : 'Y-m-d'   ,
            minDate         : 0         , // only days in the future
//          locale          : this.de_visit_date.data( 'locale' ),

            // disable dates in the past
            disable         : [
                                function( selectedDate ){
                                    var today = new Date();
                                    today.setHours(0,0,0,0);
                                    return (selectedDate < today); // return true to disable
                                },
							  ],
        });

        // init flatpickr time
        flatpickr( $( 'input[name="schedule_time"]' ), {
            inline          : true ,
            enableTime      : true ,
            noCalendar      : true ,
            time_24hr       : true ,
            dateFormat      : 'H:i',
            defaultHour     : 0    ,
            defaultMinute   : 0    ,
            minuteIncrement : 1    ,
//          locale          : this.de_visit_time.data( 'locale' ),
        });

        // update mode? ⇒ make frontend reflect g_restaurant
        if ( g_mode === 'update' ){

            for ( let [ key, value ] of Object.entries( g_restaurant ) ){

                // empty value? ⇒ do nothing
                if ( value === null ){
                    continue;
                }

                // we need strings from now on
                if ( typeof value !== 'string' ){
                    continue;
                }

                // get the DOM element
                let de = $('[name="' + key + '"]');
                if ( de.length === 0 ){
                    continue;
                }

                // input type checkbox
                if ( de.attr('type') === 'checkbox' ){
                    de.prop( 'checked', ( value == 1 ) );
                    continue;
                }

                // input type text
                if ( de.attr('type') === 'text' ){
                    de.val( value );
                    continue;
                }

                // textarea
                if ( de.is( 'textarea' ) ){
                    de.val( value );
                    continue;
                }

            }
        }

        admin_tinymce.init();
    },

    on__form__submit()
    {
        return async ( e ) => {

            e.preventDefault();

            admin_general.start_spinning();

            { // collect form data
                var schedule_data = {};

                // set restaurant id
                schedule_data.restaurant_id   = g_restaurant.id;
                schedule_data.restaurant_name = g_restaurant.name;

                // get form data
                let form_data = $('.js-form').serializeArray();

                // form data → data structures
                for ( let { name, value } of form_data ){

                    // handle opening hours separately
                    if ( name.match( /^opho_/ ) ){
                        continue;
                    }

                    // TinyMCE? ⇒ retreive value with tinymce.get()
                    if (   name == 'opening_hours_en'
                        || name == 'opening_hours_nl'
                        || name == 'opening_hours_fr'
                        || name == 'opening_hours_mcdelivery_en'
                        || name == 'opening_hours_mcdelivery_nl'
                        || name == 'opening_hours_mcdelivery_fr'
                       ){
                           var id_opening_hours = 'i-' + name ;
                           schedule_data[ name ] = admin_tinymce.get_content( id_opening_hours );
                           continue;
                   }

                    schedule_data[ name ] = value;
                }
            }

            // set sync_to_gmb to explicit 1|0
            schedule_data['sync_to_gmb'] = (schedule_data['sync_to_gmb']) ? '1' : '0';

            // validate_input
            let validated = this.validate_input( schedule_data );
            let opho_validated = admin_restaurant_opening_hours.validate_input();

            // validation error? ⇒ back to user
            if ( ! validated || ! opho_validated ){

                // show errors
                $('.c-saved.c-saved--errors').show();
                $('.c-saved.c-saved--errors').fadeOut( 2000 );

                admin_general.stop_spinning();

                return;
            }

            // get opening hours data
            schedule_data.openinghours = admin_restaurant_opening_hours.collect_opening_hours( schedule_data.restaurant_id );

            // schedule datetime
            schedule_data.schedule_datetime = schedule_data.schedule_date + ' ' + schedule_data.schedule_time + ':00';

            let insert_data = {
                'schedule_datetime': schedule_data.schedule_datetime  ,
                'restaurant_id'    : schedule_data.restaurant_id      ,
                'restaurant_name'  : schedule_data.restaurant_name    ,
                'schedule_data'    : JSON.stringify( schedule_data )  , // serialize
            };

            let response = await
            admin_crud.POST( admin_crud.posturl( '211_openinghours_schedule', 'insert' ), {
                data : insert_data,
            } );

            { // show schedule saved
                $('.c-saved.c-saved--ok').show();
                $('.c-saved.c-saved--ok').fadeOut('slow');
            }

            admin_general.stop_spinning();
        };
    },

    validate_input( schedule_data )
    {
        $('.is-error').removeClass( 'is-error' );

        let validated = true;

        // mandatory fields
        for ( let key of [ 'restaurant_id', 'schedule_date', 'schedule_time' ] ){
            if ( ! schedule_data[key] ){
                validated = false;
                $(`[name="${key}"]`).addClass( 'is-error' );
            }
        }

        return validated;
    },

}
